import React from 'react';
import './TheTeacherDashboard.css';
import Assessments from './imageFiles/Assessments.png';
import Shared from './imageFiles/Shared.png';
import Types from './imageFiles/Types.png';
import { history } from "../../../../../../helper/history"
import { routes } from '../../../../../../helper/routes';

export default function TeacherAssessmentLibrary({ totalCountMyAssessments, totalCountPublicAssessments, loadingQuestions, assessmentCounts, employeeType, typeCount, initial_loading }) {

  const libraryStats = [
    { img: Types, count: typeCount || 0, label: 'My Papers', icon: 'https://via.placeholder.com/50', isLoading: initial_loading },
  ]

  const onStatusClick = (item) => {

    const state = {
      filter: "Status",
      name: item.status_name,
      value: item.status_id,
    }

    history.push({
      pathname: routes.view_assessment_review,
      state: { ...state },
    });

  };

  return (
    <div className="teacher-assessment-library">
      <h6 className="assessment-title">{employeeType === "TEACH" ? "My Papers" : "Papers"}</h6>
      {employeeType !== "TEACH" && (
        <div className="row">
          <div className="col-md-6 col-12 mb-3 px-0 assessment-col-left">
            <div className="assessment-box">
              <img src={Assessments} alt="My Assessments" className="assessment-icon" />
              <div>
                <div className="assessment-label">My Papers</div>
                {loadingQuestions ?(
                  <div
                    className="stu-card-title pt-2 col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="assessment-count">{totalCountMyAssessments || "0"}</div>
                )}

              </div>
            </div>
          </div>

          <div className="col-md-6 col-12 mb-3 px-0 assessment-col-right">
            <div className="assessment-box">
              <img src={Shared} alt="Shared with me" className="assessment-icon" />
              <div>
                <div className="assessment-label">All Papers</div>
                {loadingQuestions ?(
                  <div
                    className="stu-card-title pt-2 col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="assessment-count">{totalCountPublicAssessments || "0"}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* for data entry and reviwer both */}
      {/* {(employeeType === "TEACH" &&
        <div className="row">
          <div className="col-12 col-md-12 px-0">
            <div className="row">
              {libraryStats.map((item, index) => (
                <div className="col-12 mb-3" key={index}>
                  <div className="library-box text-center">
                    <img src={item.img} alt={item.label} className="library-icon mb-2" />
                    {item.isLoading ? (
                      <div className="stu-card-title pt-2 d-flex justify-content-center align-items-center">
                        <i className="fas fa-spinner fa-spin"></i>
                      </div>
                    ) : (
                      <div className="library-count">{item.count || 0}</div>
                    )}
                    <div className="library-label">My Papers</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}  */}
      {/* Bottom row: Assessment counts (full width) */}
      <div className="col-12 mt-3 px-0">
        <div className="row h-100 d-flex align-items-end">
          {/* {assessmentCounts?.map((item, index) => (
            <div className="col-md-6 col-12 mb-3 px-0" key={index}>
              <div className="review-badge d-flex justify-content-between align-items-center">
                <div
                  className="flex-grow-1 text-start px-0"
                  onClick={() => onStatusClick(item)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="badge-label text-primary text-decoration-underline">
                    {item?.status_name || "N/A"}
                  </span>
                </div>
                <div className="text-end px-0">
                  <span className="badge-value">{item?.count || "0"}</span>
                </div>
              </div>
            </div>
          ))} */}

          {assessmentCounts?.map((item, index) => {
            const disabledStatuses = ["Initial", "Ready", "Published"];
            const isDisabled = disabledStatuses.includes(item?.status_name);

            return (
              <div className="col-md-6 col-12 mb-1 px-0" key={index}>
                <div className="review-badge d-flex justify-content-between align-items-center">
                  <div
                    className="flex-grow-1 text-start px-0"
                    onClick={() => {
                      if (!isDisabled) {
                        onStatusClick(item);
                      }
                    }}
                    style={{
                      cursor: isDisabled ? "default" : "pointer"
                    }}
                  >
                    <span
                      className={`badge-label text-primary ${!isDisabled ? 'text-decoration-underline' : ''}`}
                    >
                      {item?.status_name || "N/A"}
                    </span>
                  </div>
                  <div className="text-end px-0">
                    <span className="badge-value">{item?.count || "0"}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
